import { Component, ChangeDetectionStrategy} from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
    selector: 'number-component',
    template: `
    <input     
      class ="ag-input-field-input ag-text-field-input"
      type="text" 
      [(ngModel)]="currentValue"
      (input)="onInputBoxChanged()"
    />`,
})
export class CustomFloatingFilterComponent
    implements IFloatingFilterAngularComp {
    params!: IFloatingFilterParams;
    currentValue: number | null | string = null;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    onParentModelChanged(parentModel: any) {
        // When the filter is empty we will receive a null value here
        if (parentModel == null) {
            this.currentValue = null;
        } else {
            this.currentValue = parentModel;
        }
    }

    onInputBoxChanged() {
        if (this.currentValue == null) {
            // Remove the filter
            this.params.parentFilterInstance((instance: any) => {
                instance.methodTakingValueFromFloatingFilter(null);
            });
            return;
        }
        this.params.parentFilterInstance((instance: any) => {
            instance.methodTakingValueFromFloatingFilter(this.currentValue);
        });
    }
}
